import CICESE from '../../../assets/images/sponsors/logo_cicese.png';
import LAE from '../../../assets/sponsors/LAE Version 1_C.png';
import CNYN from '../../../assets/images/sponsors/cnyn.jpeg';
import SIE from '../../../assets/sponsors/ise.png';
import EDS from '../../../assets/sponsors/eds.jpeg';
import CORONA from '../../../assets/sponsors/hotel corona.jpg';
import FOTONIK from '../../../assets/sponsors/fotonik.png';
import Vakmo from '../../../assets/sponsors/vakmo.jpeg';
import Caracol from '../../../assets/sponsors/instituteLogo caracol.jpg';
import Anyover from '../../../assets/sponsors/anyover.jpeg';
import MUSU from '../../../assets/sponsors/LOGO_MUSU.jpg';
import COSTA from '../../../assets/sponsors/costa_azul.jpeg';

export const Sponsors = () => {
  return (
    <>
      <section className="snn-page-section snn-topics">
        <h2 className="snn-title">Sponsors</h2>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
            <img src={CNYN} alt="cic logo"/>
          </div>
          <div>
            <img src={CICESE} alt="cic logo"/>
          </div>
          <div>
            <img src={SIE} alt="cic logo"/>
          </div>
          <div>
            <img src={LAE} alt="cic logo"/>
          </div>
        </div>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
            <img src={EDS} alt="cic logo"/>
          </div>
          <div>
            <img src={Caracol} alt="cic logo"/>
          </div>
          <div>
            <img src={CORONA} alt="cic logo"/>
          </div>
          <div>
            <img src={Vakmo} alt="cic logo"/>
          </div>
        </div>
        <div className="snn-topic-section snn-sponsors-section">
          <div>
              <img src={COSTA} alt="cic logo"/>
          </div>
            <div>
                <img src={Anyover} alt="cic logo"/>
            </div>
          <div>
            <img src={MUSU} alt="cic logo"/>
          </div>
          <div>
            <img src={FOTONIK} alt="cic logo"/>
          </div>
        </div>
      </section>
    </>
  );
};
